// Auto-generated by generate-emotes.js - DO NOT EDIT
export const CUSTOM_EMOTE_PATTERN = "(:frøken-smult:|:tonje-hater:|:flippklipp:|:muldvarpen:|:pinnsvinet:|:tonje-love:|:herr-bæsj:|:kp-bart-1:|:kp-bart-2:|:pingvinen:|:riksløven:|:tonje-wii:|:kp-dilla:|:vulkanen:|:ekornet:|:kp-tenk:|:piraten:|:tonjeee:|:humla:|:kp-on:|:yt:)";
/**
 * Returns a new RegExp instance for matching custom emotes.
 * Creates a fresh instance each time to avoid shared state issues with .lastIndex.
 */
export function customEmotesPattern() {
    return /(:frøken-smult:|:tonje-hater:|:flippklipp:|:muldvarpen:|:pinnsvinet:|:tonje-love:|:herr-bæsj:|:kp-bart-1:|:kp-bart-2:|:pingvinen:|:riksløven:|:tonje-wii:|:kp-dilla:|:vulkanen:|:ekornet:|:kp-tenk:|:piraten:|:tonjeee:|:humla:|:kp-on:|:yt:)/g;
}
//# sourceMappingURL=custom-regex.js.map